/**
 * useIsMobile — true below Tailwind's `md` breakpoint (768px).
 *
 * Tailwind's `hidden md:block` / `md:hidden` pairing is fine for static
 * markup, but list pages use it to render a full table AND a full card stack,
 * mapping every row twice on every viewport. Gating on this hook renders only
 * the tree that is actually visible.
 *
 * Mirrors the matchMedia usage already in dashboard/utils/chartTheme.js.
 */
import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia?.(MOBILE_QUERY).matches ?? false,
  );

  useEffect(() => {
    const mql = window.matchMedia?.(MOBILE_QUERY);
    if (!mql) return undefined;
    const onChange = (e) => setIsMobile(e.matches);
    // Safari < 14 only has the deprecated addListener.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isMobile;
}

export default useIsMobile;
